/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const topic_name = feature.project.parseCodeExpression(feature.getSettingValue('TOPIC_NAME'), [], TibboDataType.STRING);
    const NAME = feature.getSettingValue('NAME');
    const QOS = feature.getSettingValue('QOS');
    const ID = feature.getID();

    const topicNameIdentifier = NAME.replace(/ /g, '_').toUpperCase();

    //     blocks.push({
    //         location: 'GLOBAL_DECLARATIONS',
    //         blockType: BlockType.CODE,
    //         template: `declare mqtt_topic_${topicNameIdentifier} as string`,
    //     });

    //     blocks.push({
    //         location: 'GLOBAL_DIMS',
    //         blockType: BlockType.CODE,
    //         template: `dim mqtt_topic_${topicNameIdentifier} as string`,
    //     });

    //     blocks.push({
    //         location: 'boot',
    //         blockType: BlockType.CODE,
    //         template: `
    // mqtt_topic_${topicNameIdentifier} = ${topic_name}`,
    //     });

    blocks.push({
        location: 'callback_mqtt_notif',
        blockType: BlockType.CODE,
        id: `mqtt_notif_${topicNameIdentifier}`,
        template: `
    if (mqtt_topic_match(${topic_name}, (const char*)evt->param.publish.message.topic.topic.utf8)) {
        /****mqtt_notif_${feature.getSettingValue('TOPIC_NAME', true)}****/
    }`,
    });

    blocks.push({
        location: 'callback_mqtt_connect_ok',
        id: 'mqtt_connect_ok_sub',
        blockType: BlockType.CODE,
        template: `
int rc;
struct mqtt_topic sub_topics[] = {
/****MQTT_SUBSCRIBE****/
};
if (sizeof(sub_topics) == 0) {
    LOG_ERR("No topics to subscribe to");
    return;
}
const struct mqtt_subscription_list sub_list = {
    .list = sub_topics,
    .list_count = ARRAY_SIZE(sub_topics),
    .message_id = 5841u
};

LOG_INF("Subscribing to %d topic(s)", sub_list.list_count);

rc = mqtt_subscribe(client, &sub_list);
if (rc != 0) {
    LOG_ERR("MQTT Subscribe failed [%d]", rc);
}
`,
    });

    blocks.push({
        location: 'MQTT_SUBSCRIBE',
        blockType: BlockType.CODE,
        template: `
{
    .topic = {
        .utf8 = (uint8_t*)(${topic_name}).c_str(),
        .size = (${topic_name}).length(),
    },
    .qos = ${QOS},
}
`,
    });

    return blocks;
};
